import { createClient, type SupabaseClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL as string | undefined
const supabaseKey = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY as string | undefined

/** Whether the build carries a Supabase backend configuration. */
export const hasSupabaseConfig = !!(supabaseUrl && supabaseKey)

/**
 * Guarded client (INC-025 / ADR-021): a build without VITE_SUPABASE_* no
 * longer throws at import time (createClient rejects undefined credentials
 * eagerly). Cloud features stay broken-loud — any actual use of the client
 * throws with a precise message — but the offline builder can boot. The full
 * backendless build target remains future work (see `docs/todo.md`).
 */
function unconfiguredClient(): SupabaseClient {
  return new Proxy({} as SupabaseClient, {
    get(_t, prop) {
      throw new Error(
        `Supabase is not configured (accessed supabase.${String(prop)}): ` +
          'set VITE_SUPABASE_URL and VITE_SUPABASE_PUBLISHABLE_KEY to enable cloud features.',
      )
    },
  })
}

export const supabase: SupabaseClient = hasSupabaseConfig
  ? createClient(supabaseUrl!, supabaseKey!)
  : unconfiguredClient()
